import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .display {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;

    img {
      width: 100%;
      max-height: 450px;
      object-fit: contain;
      background: #f0f0f0;
      border-radius: 8px;
      border: 1px solid #eee;
    }

    .info {
      background: #f9f9f9;
      padding: 4px;
      border-radius: 8px;
      text-align: center;

      strong {
        color: #333;
        font-size: 16px;
      }
    }
  }

  .empty {
    padding: 60px;
    text-align: center;
    color: #666;
    font-style: italic;
  }
`;
